// LeverandorLogos.js
import React, { useState } from "react";
import { motion } from "framer-motion";
import Modal from "react-modal";
import { leverandorer } from "../data/leverandorer"; // ✅ Import fra datafil

export default function LeverandorLogos() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      {/* 🎞️ Horisontal logo-loop */}
      <div
        style={{
          overflow: "hidden",
          background: "#ffffff",
          padding: "1rem 0",
          borderRadius: "12px",
          position: "relative",
        }}
      >
        <motion.div
          style={{
            display: "flex",
            gap: "3rem",
            width: "max-content",
          }}
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            repeat: Infinity,
            duration: 60,
            ease: "linear",
          }}
        >
          {[...leverandorer, ...leverandorer].map((lev, i) => (
            <motion.img
              key={i}
              src={lev.logo}
              alt={lev.navn}
              style={{
                height: "60px",
                cursor: "pointer",
                flexShrink: 0,
              }}
              whileHover={{ scale: 1.1 }}
              onClick={() => setSelected(lev)}
            />
          ))}
        </motion.div>
      </div>

      {/* 🧾 Modal for kontaktpersoner */}
      <Modal
        isOpen={!!selected}
        onRequestClose={() => setSelected(null)}
        contentLabel="Kontaktpersoner"
        style={{
            overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                zIndex: 1000,
            },
            content: {
                width: "83%",
                maxWidth: "600px",
                maxHeight: "80vh",
                overflowY: "auto",
                margin: "auto",
                borderRadius: "12px",
                padding: "1.5rem",
                inset: "unset",
                position: "relative",
            },
        }}
      >
        {selected && (
          <>
            <h2 style={{ marginBottom: "1rem" }}>{selected.navn}</h2>
            {selected.kontaktpersoner.map((p, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  gap: "1rem",
                  marginBottom: "1.5rem",
                  borderBottom: "1px solid #eee",
                  paddingBottom: "1rem",
                }}
              >
                <img
                  src={p.bilde}
                  alt={p.navn}
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div>
                  <h4 style={{ margin: "0 0 0.25rem 0" }}>{p.navn}</h4>
                  <p style={{ margin: 0 }}>{p.rolle}</p>
                  <p style={{ margin: 0 }}>📞 {p.tlf}</p>
                  <p style={{ margin: 0 }}>✉️ {p.epost}</p>
                </div>
              </div>
            ))}
          </>
        )}

        {/* ❌ Lukkeknapp */}
        <button
          onClick={() => setSelected(null)}
          aria-label="Lukk"
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            background: "transparent",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: "#333",
          }}
        >
          &times;
        </button>
      </Modal>
    </>
  );
}
